import {CreateTestingResulForm} from "../types/create-testing-result.types";

export const createTestingResultFormFields: Array<CreateTestingResulForm> = [
  {
    label: 'Комментарий',
    fieldName: 'comment',
    type: 'textarea'
  }
]
